import type { GovernmentDependency } from "~/types/company";

interface FinancialForDependency {
	year: number;
	revenue: number | null;
}

interface ContractSummaryForDependency {
	supplierByYear: Array<{
		year: number;
		totalValueCzk: number | null;
		contractCount: number;
	}>;
}

export function deriveGovernmentDependency(
	financials: FinancialForDependency[],
	contracts: ContractSummaryForDependency | null,
): GovernmentDependency | null {
	if (!contracts) return null;

	const latestFinancial = financials.find((financial) => financial.revenue != null) ?? null;
	if (!latestFinancial) return null;

	const annualContracts = contracts.supplierByYear.find(
		(summary) => summary.year === latestFinancial.year,
	);
	if (!annualContracts || annualContracts.contractCount === 0) return null;

	const revenue = latestFinancial?.revenue ?? null;
	const ratio =
		revenue != null && revenue > 0 && annualContracts.totalValueCzk != null
			? annualContracts.totalValueCzk / revenue
			: null;
	const riskLevel = ratio == null ? null : ratio > 0.6 ? "high" : ratio > 0.3 ? "moderate" : "low";

	return {
		ratio,
		totalContractValueCzk: annualContracts.totalValueCzk,
		latestRevenue: revenue,
		revenueYear: latestFinancial.year,
		riskLevel,
		contractCount: annualContracts.contractCount,
	};
}
